import {
  QUOTE_LINE_INFO_TABS,
  QUOTE_LINE_PART_DETAILS_EXTRA_COMPONENTS,
  QUOTE_PRICE_FIELDS,
  QUOTE_PRICE_STRATEGY_BADGE_COLORS,
} from '../constants';
import { PriceStrategyUIConfigEntry } from '../types';

export const priceSegmentationWithTargetGrossMarginUIConfig: PriceStrategyUIConfigEntry =
  {
    badge: {
      color: QUOTE_PRICE_STRATEGY_BADGE_COLORS.MARGIN,
      label: 'Segmentation',
    },
    partDetailsExtraComponents: [
      QUOTE_LINE_PART_DETAILS_EXTRA_COMPONENTS.PART_COMPLEXITY,
    ],
    fields: [
      {
        field: QUOTE_PRICE_FIELDS.quantity,
        editable: true,
      },
      {
        field: QUOTE_PRICE_FIELDS.unitCost,
        editable: false,
      },
      {
        field: QUOTE_PRICE_FIELDS.baseGrossMargin,
        editable: true,
      },
      {
        field: QUOTE_PRICE_FIELDS.priceAdjustmentAmount,
        editable: false,
      },
      {
        field: QUOTE_PRICE_FIELDS.unitPrice,
        editable: true,
      },
      {
        field: QUOTE_PRICE_FIELDS.grossMargin,
        editable: false,
      },
      {
        field: QUOTE_PRICE_FIELDS.leadTimeWeeks,
        editable: true,
      },
    ],
    tabs: [
      QUOTE_LINE_INFO_TABS.COST_OVERVIEW,
      QUOTE_LINE_INFO_TABS.QUOTE_HISTORY,
      QUOTE_LINE_INFO_TABS.PRICE_SEGMENTS,
      QUOTE_LINE_INFO_TABS.COST_ESTIMATOR,
      QUOTE_LINE_INFO_TABS.ORDER_HISTORY,
      QUOTE_LINE_INFO_TABS.COST_BREAKS,
    ],
  } as const;
